import { useCallback, useMemo, useState } from 'react';
import { Order } from '../../../../utils/apollo/graphqlSchema';
import { IPreviewDataRows } from '../utils';

interface IProps {
  previewData: IPreviewDataRows | null;
}

const useSortablePreviewDataRows = ({ previewData }: IProps) => {
  const [sortColumnIndex, setSortColumnIndex] = useState(-1);
  const [sortOrder, setSortOrder] = useState(Order.Asc);

  const sortedRows = useMemo(() => {
    if (!previewData) {
      return [];
    }
    if (sortColumnIndex < 0 || sortColumnIndex >= previewData.header.length) {
      return previewData.rows;
    }
    return (
      previewData?.rows.sort((a, b) => {
        const v1 = a.values[sortColumnIndex];
        const v2 = b.values[sortColumnIndex];
        return sortOrder === Order.Asc
          ? v1.localeCompare(v2)
          : v2.localeCompare(v1);
      }) ?? []
    );
  }, [previewData, sortColumnIndex, sortOrder]);

  const onHeaderClick = useCallback(
    (colIndex: number) => {
      if (sortColumnIndex === colIndex) {
        if (sortOrder === Order.Desc) {
          // unsort
          setSortOrder(Order.Asc);
          setSortColumnIndex(-1);
        } else {
          setSortOrder(Order.Desc);
        }
      } else {
        setSortColumnIndex(colIndex);
        setSortOrder(Order.Asc);
      }
    },
    [sortColumnIndex, sortOrder],
  );

  return {
    sortedRows,
    onHeaderClick,
    sortColumnIndex,
    sortOrder,
  };
};

export default useSortablePreviewDataRows;
